"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    assistChipDefaultVariants: ()=>assistChipDefaultVariants,
    assistChipSlots: ()=>assistChipSlots
});
const assistChipSlots = {
    containerSlot: 'antialiased focus-visible:ring-2 focus-visible:ring-primary-8 flex items-center border border-solid px-2 py-[1px] rounded-action-sm focus-visible:outline-none focus-visible:ring-offset-2 hover:cursor-pointer hover:aria-selected:cursor-pointer transition-all',
    iconLeftSlot: '',
    opacity0: 'flex items-center opacity-0',
    opacity100: 'flex items-center opacity-100',
    faviconSlot: 'h-[18px] w-[18px]',
    faviconImg: 'rounded-xsm',
    labelTextSlot: 'p-1 whitespace-nowrap text-body2',
    spinnerSlot: 'absolute inset-0 flex justify-center'
};
const assistChipDefaultVariants = {
    emphasis: 'regular'
};
exports.assistChipDefaultVariants = __webpack_exports__.assistChipDefaultVariants;
exports.assistChipSlots = __webpack_exports__.assistChipSlots;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "assistChipDefaultVariants",
    "assistChipSlots"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
